import { useCallback, useEffect, useMemo, useState } from "react";
import InfoTextFormComponent from "../../PersonalInformation/components/forms/FormComponents/InfoTextFormComponent";
import { useDispatch, useSelector } from "react-redux";
import DateSelectionForm from "../../../../shared/components/DateSelectionForm";
import {
  setQuestionAnswer,
  updateOtherAdultAction
} from "../../../../redux/actions";
import SinTextFormComponent from "../../PersonalInformation/components/forms/FormComponents/SinTextFormComponent";

const REDUX_APP_PROPERTY = "otherAdultsInformation";

const OtherAdultsFormComponent = ({
  t,
  i18n,
  otherAdultInfo,
  index,
  setIsError,
  localId,
  formErrors,
  getDate,
  resetOtherAdultFormError
}) => {
  const dispatch = useDispatch();

  // const [formErrors, setFormErrors] = useState({
  //   ...initalOtherAdult
  // });

  const reduxProperty = REDUX_APP_PROPERTY + "[" + index + "]";

  // const [ageError, setAgeError] = useState(false);
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [dobFlag, setDobFlag] = useState(false);

  const datesData = useSelector((state) => state.datesReducer);
  let dates, currentLanguageDates;
  if (datesData) {
    dates = datesData["en"];
    currentLanguageDates = datesData[i18n.language];
  }
  const dateOfBirth = otherAdultInfo.dateOfBirth;
  const birthYear = otherAdultInfo.birthYear;

  const [dob, setDob] = useState(dateOfBirth);
  const taxFiledYear = currentLanguageDates
    ? currentLanguageDates?.taxFiled
    : "#YEAR";

  const nameHelper = t("other_adult_personal_info.name_helper").replace(
    "#YEAR",
    taxFiledYear
  );

  /*
  let ageErrorDateComponent;
  if (
    currentLanguageDates &&
    i18n.language === "fr" &&
    canHaveFrenchSuperscript(currentLanguageDates?.endDate)
  ) {
    const dateParts = currentLanguageDates?.endDate.split(" ");
    ageErrorDateComponent = (
      <>
        <span>{dateParts[0]}</span>
        <sup>{"er "}</sup>
        {dateParts[1] + " "}
        {dateParts[2]}
      </>
    );
  } else {
    ageErrorDateComponent = currentLanguageDates?.endDate;
  }
  */

  const handleSetAppProperty = useCallback(
    (fieldName, value) => {
      const newAdultInformation = {
        ...otherAdultInfo,
        [fieldName]: value
      };
      dispatch(updateOtherAdultAction(newAdultInformation));
    },
    [dispatch, otherAdultInfo]
  );

  const dobStatusClasses = useMemo(() => {
    if (
      (!formErrors?.dateOfBirth || !formErrors?.ageError || !formErrors?.dob) &&
      !dobFlag
    ) {
      return "ns-form-group";
    } else {
      return "ns-form-group has-error ns-form-group-message-error";
    }
  }, [formErrors, dobFlag]);

  const validateFirstName = (firstName, valid) => {
    // const firstNameError = validateFullNameErrors(firstName);

    if (formErrors?.firstName) {
      resetOtherAdultFormError("firstName", false, otherAdultInfo.localId);
    }
  };

  const validateLastName = (lastName, valid) => {
    // const lastNameError = validateFullNameErrors(lastName);
    if (formErrors?.lastName) {
      resetOtherAdultFormError("lastName", false, otherAdultInfo.localId);
    }
  };

  const getHumanReadableMonth = (month) => {
    switch (month) {
      case 0:
        return "January";
      case 1:
        return "February";
      case 2:
        return "March";
      case 3:
        return "April";
      case 4:
        return "May";
      case 5:
        return "June";
      case 6:
        return "July";
      case 7:
        return "August";
      case 8:
        return "September";
      case 9:
        return "October";
      case 10:
        return "November";
      case 11:
        return "December";
      default:
        return "";
    }
  };

  const humanReadableDate = (date) => {
    let dateObj = new Date(date);

    return `${dateObj.getDate()} ${getHumanReadableMonth(
      dateObj.getMonth()
    )} ${dateObj.getFullYear()}`;
  };

  const getDayAndMonth = (day, month, year) => {
    setDay(day);
    setMonth(month);
    setYear(year);

  };

  const validateSIN = (socialInsuranceNumber, valid) => {
    if (formErrors?.socialInsuranceNumber) {
      //const SINError = validateSINNumberErrors(socialInsuranceNumber)
      resetOtherAdultFormError(
        "socialInsuranceNumber",
        false,
        otherAdultInfo.localId
      );
    }
  };

  useEffect(() => {
    handleSetAppProperty("birthYear", year);
    getDate(localId, day, month, year)
  }, [day, month, year, dob]);

  const onDateOfBirthChange = (date) => {
    handleSetAppProperty("dateOfBirth", date);
    setDob(date);
    // dispatch(setQuestionAnswer(6, humanReadableDate(date)));
    if (formErrors?.dateOfBirth) {
      resetOtherAdultFormError("dateOfBirth", false, otherAdultInfo.localId);
    } else if (formErrors?.ageError) {
      resetOtherAdultFormError("ageError", false, otherAdultInfo.localId);
    } else if (formErrors?.dobValid) {
      resetOtherAdultFormError("dobValid", false, otherAdultInfo.localId);
    }

    // if (date === 0 || date === null) {
    //   resetOtherAdultFormError("dateOfBirth", true, otherAdultInfo.localId);
    //   return;
    // } else {
    //   if (formErrors.dateOfBirth) {
    //     resetOtherAdultFormError("dateOfBirth", false, otherAdultInfo.localId);
    //     return;
    //   }
    // }
    // const birthDate = new Date(date);
    // const age = getApplicantsAge(date);
    // if (age < 18 || birthDate.getFullYear() < 1900) {
    //   resetOtherAdultFormError("ageError", true, otherAdultInfo.localId);
    // } else {
    //   if (formErrors.ageError) {
    //     resetOtherAdultFormError("ageError", false, otherAdultInfo.localId);
    //   }
    // }
  };

  return (
    <div className="row">
      <div className="col-xs-12 col-md-8">
        <div style={{ marginBottom: '1.5em' }}>
          <InfoTextFormComponent
            label={t("other_adult_personal_info.first_name")}
            helperText={nameHelper}
            reduxAppProperty={reduxProperty}
            changeObjectPropertyAction={handleSetAppProperty}
            fieldName={"firstName"}
            validate={validateFirstName}
            error={formErrors?.firstName}
            isValid={formErrors?.firstName === "" ? "" : !formErrors?.firstName}
            setIsError={setIsError}
            // value={firstName}
            maxLength={"35"}
          />
        </div>
        <div style={{ marginBottom: '1.5em' }}>
          <InfoTextFormComponent
            label={t("other_adult_personal_info.last_name")}
            helperText={nameHelper}
            reduxAppProperty={reduxProperty}
            changeObjectPropertyAction={handleSetAppProperty}
            fieldName={"lastName"}
            validate={validateLastName}
            error={formErrors?.lastName}
            isValid={formErrors?.lastName === "" ? "" : !formErrors?.lastName}
            setIsError={setIsError}
            // value={lastName}
            maxLength={"35"}
          />
        </div>
        <div style={{ paddingBottom: "1.5em" }}>
          <div className={`${formErrors?.dateOfBirth || formErrors?.ageError || formErrors?.dob ? 'ns-form-group has-error ns-form-group-message-error' : 'ns-form-group '}`}>
            <div className="ns-label-wrapper">
              <label className={"ns-label"}>
                {t("other_adult_personal_info.date_of_birth")}
              </label>
            </div>
            <div style={{ marginBottom: ".5em" }} className="ns-hint">
              {t("other_adult_personal_info.date_of_birth_helper")}
            </div>
            <div style={{ marginBottom: ".5em" }}>
              {(formErrors?.dateOfBirth || formErrors?.ageError || formErrors?.dob) && (
                <div id="street-address-error" className="help-block-focused">
                  <i
                    aria-label={t("errors.hidden_error_msg")}
                    className="fa fa-exclamation-circle error-indicator errorAlert"
                    aria-hidden="true"
                  />
                  <span className="ns-visually-hidden">
                    {t("errors.hidden_error_msg")}
                  </span>
                  <span style={{ marginLeft: "10px" }}>
                    {formErrors.dateOfBirth
                      ? t("personal_information.date_of_birth_error")
                      : formErrors.ageError
                        ? t("personal_information.age_error")
                        : t("personal_information.date_error")}
                  </span>
                </div>
              )}
              <DateSelectionForm
                id={"otherAdult-information-date" + 1}
                date={dateOfBirth}
                language={i18n.language}
                getDayAndMonth={getDayAndMonth}
                onDateChange={onDateOfBirthChange}
              />
            </div>
          </div>
        </div>
        <SinTextFormComponent
          label={t("other_adult_personal_info.SIN_Number")}
          reduxAppProperty={reduxProperty}
          changeObjectPropertyAction={handleSetAppProperty}
          fieldName={"socialInsuranceNumber"}
          validate={validateSIN}
          error={formErrors?.socialInsuranceNumber}
          isValid={
            formErrors?.socialInsuranceNumber === ""
              ? ""
              : !formErrors?.socialInsuranceNumber
          }
          setIsError={setIsError}
          // value={socialInsuranceNumber}
          maxLength={"11"}
          keypadType="numeric"
        />
      </div>
    </div>
  );
};

export default OtherAdultsFormComponent;
